<ng-content select="qe-info-group-key"></ng-content>
<ng-content select="qe-info-group-value"></ng-content>
